/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventBus } from "../event-bus";
import { Account } from "../models/Account";
import { Store } from "vuex";
import { SystemConfig } from "../models/Config";
import Vue from "vue";
import store from "@/store";
import { UsbStatusModel } from "@/models/UsbStatus";
import { resolveWsUrl } from "./wsUrl";


export default class Socket extends Vue{
  _socket?: any;
  isConnected?:boolean;
  timer?:number;

  constructor(url?: string,timer?:number) {
    super();
    if (url=== undefined){
      this._socket=null;
      this.isConnected=false;
     // this.timer=-1;
    }else{
      this._socket = new WebSocket(resolveWsUrl(url) as string);
      this.isConnected=true;
    //  this.timer=timer;
      this.addEventListeners();
    }
  }
  

  addEventListeners() {
      //Back end: ensure socket is not already opened before opening.
    this._socket.onopen = (event: any) => {
      console.log("open, ", event);
      this.isConnected=true;

    };
    //new Socket(`${process.env.VUE_APP_ACCOUNTLOGS_URL}?id=${id}`);
    this._socket.onmessage = (event: any) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg.type === "System") {
          const finalMessage: string =
          msg.active_connections + "/" + msg.max_connections;
          const systemConf:SystemConfig=new SystemConfig(msg.infoStatus.IpAddress, msg.infoStatus.CpuUsage, msg.infoStatus.RamUsage, msg.infoStatus.DbServiceStatus, msg.infoStatus.VpnServiceStatus, msg.infoStatus.HsmConnectivityStatus, msg.infoStatus.HsmConnectivityStatus2,msg.infoStatus.ExchangeServerAddress, msg.infoStatus.ExchangeServerPort); 
          const usbStatus:UsbStatusModel=new UsbStatusModel(msg.usbStatus.creationRunningCode,msg.usbStatus.createUserFinished,msg.usbStatus.squashFileFinished,msg.usbStatus.formatDeviceFinished,msg.usbStatus.loadImageFinished,msg.usbStatus.checkFileSize,msg.usbStatus.error);  
          //console.log(usbStatus)       
          EventBus.$emit("refreshUsage", finalMessage,systemConf);
          EventBus.$emit("refreshUsbStatus", usbStatus);

        } else if (msg.type === "Accounts") {
          const finalMessage: Array<Account> = msg.results;
          EventBus.$emit("refreshAccounts", finalMessage);
        } else if (msg.type === "AccountLogs") {
          const finalMessage: Array<Account> = msg.results;
          EventBus.$emit("refreshAccountLogs", finalMessage);
        } else if (msg.type === "EventLogs") {
          const finalMessage: any = msg.event;
          EventBus.$emit("eventLogs", finalMessage);
        }
      } catch (error) {
        console.log("ERROR:", error);
      }
    };

    this._socket.onerror = (error: any) => {
      console.log("socket.onerror:", error);
      this.isConnected=false;
    };

    this._socket.onclose=(event:any)=>{
      this.isConnected=false; 
      store.dispatch('checkSockets',this._socket);

    };      
    
  }

   closeSocket() {
    this._socket.close(1000);
    this.isConnected=false;
    console.log("socketClosed");
  }
}
